import { req } from "./../api/api.config";
import userState from "../state/user.state";
import controllerState from "../state/controller.state";

class apiRequest {
  login = async (_email, _password) => {
    try {
      const res = await req.post("auth/", {
        email: _email,
        password: _password,
      });
      console.log(res, _email, _password);
      if (!res) return;
      return res;
    } catch (e) {
      console.error("login ", e);
      if (e.message === "Network Error") {
        return alert("Нет подключения к серверу");
      }
    }
  };

  getProfile = async () => {
    try {
      const res = await req("my_profile/");
      if (res) {
        console.log(res.data.data);
        const u = res.data.data;
        userState.setProfile(
          u.id,
          u.first_name,
          u.last_name,
          u.father_name,
          u.email,
          u.phone,
          u.organization,
        );
        this.getMyContollers();
      }
    } catch (e) {
      console.error("getProfile", e);
    }
  };

  patchprofile = async (obj) => {
    try {
      const res = await req.patch("my_profile/", obj);
      if (res) {
        return res.data;
      }
    } catch (e) {
      console.error(e);
    }
  };

  newUser = async (data) => {
    try {
      const res = await req.post("auth/registration", data);

      if (res) {
        console.log(res.data);
      }
      return res.data;
    } catch (e) {
      console.error(e);
    }
  };

  getMyContollers = async () => {
    try {
      const res = await req("my_profile/my_controller/");
      if (res.data.data.controller) {
        controllerState.setControllers(res.data.data.controller);
        return res.data.data.controller;
      } else {
        controllerState.setControllers([]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  addNewController = async (id) => {
    try {
      const res = await req.post("my_profile/add_controller", {
        identifier: id,
      });
      return res;
    } catch (e) {
      console.error(e);
    }
  };

  patchController = async (data) => {
    try {
      const res = await req.patch("controller_data", data);
      if (res) {
        return res.status;
      }
    } catch (e) {
      console.error(e);
    }
  };
  getLogController = async (id, split_by_tags) => {
    console.log("555");
    const res = await req(
      `save_data?split_by_tags=${split_by_tags}&size=200&number=1&controller_id=${id}`,
    );
    if (res) {
      await controllerState.createStructureHistoryParameters(
        res.data.data.request,
      );
      return res.data.data;
    }
  };

  // getLogControllerTimeout = async (id, split_by_tags) => {
  //   const res = await req(
  //     `save_data?split_by_tags=${split_by_tags}&size=200&number=1&controller_id=${id}`,
  //   );
  //   if (res) {
  //     await controllerState.createStructureHistoryParameters(
  //       res.data.data.request,
  //     );
  //     // return structure;
  //   }
  // };

  getHistoryController = async (id, number = 1, size = 100) => {
    console.log("444");
    try {
      const res = await req(
        `save_data/history?size=${size}&number=${number}&controller_id=${id}`,
      );
      if (res?.data?.data) {
        const payload = res.data.data;
        controllerState.setHistoryPagination(payload);
        await controllerState.createStructureHistoryParameters(
          payload.request ?? [],
        );
        return payload;
      }
    } catch (e) {
      console.error("getHistoryController", e);
    }
  };

  logVal = async (log) => {
    const res = await req.post("logs_val", log);
  };
  removeLogVal = async (id) => {
    const res = await req.delete(`logs_val/${id}`);
  };
  removeController = async (identifier) => {
    try {
      const res = await req.delete(`my_profile/${identifier}`);
      return res.data.success;
    } catch (e) {
      console.error(e);
    }
  };

  addCategoryController = async (name) => {
    try {
      const res = await req.post("categories", {
        categories_controller: name,
      });

      if (res.status === 200) {
        controllerState.createController(controllerState.controller_id);
      }
    } catch (e) {
      console.error(e);
    }
  };

  getAllCategory = async () => {
    try {
      const res = await req("categories");
      if (res.status) {
        return res.data.data.request;
      }
    } catch (e) {
      console.error(e);
    }
  };

  updateControllerTag = async (id, data) => {
    try {
      const res = await req.patch(`controller_tag/${id}`, data);
      console.log("updateControllerTag", res, id, data);
      if (res.status === 200) {
        controllerState.createController(controllerState.controller_id);
        return res.status;
      }
    } catch (e) {
      console.error(e);
    }
  };
}
export default new apiRequest();
